import { FlatTreeControl } from '@angular/cdk/tree';
import { TreeLikeFlatNode } from '@common/data-models/search-results/search-results';
import { NavigationDirection } from '@common/enums/navigation-direction';
import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';
import { ViewStateTypesEnum } from '@src/suite/common/enums/viewstate-types';

export const navigateTo = (
    navigatation: NavigationDirection,
    currentNodeUuid: string,
    treeControl: FlatTreeControl<TreeLikeFlatNode<unknown>, string>,
    vs?: ViewStateRecord,
    baseLvl?: number
): TreeLikeFlatNode<unknown> => {
    // We need to add the baseLvl to the function call, because the treeControl is not the same for cast when iterate over the side records
    const baseLvls = baseLvl ?? (vs?.viewStateType === ViewStateTypesEnum.ASSIGNMENT ? 2 : 1);
    let currentIndex = treeControl.dataNodes?.findIndex(item => item?.uniqueId === currentNodeUuid);
    if (currentIndex === -1) {
        currentIndex = treeControl.dataNodes?.findIndex(item => (item?.object as StorytellingRecord)?.Guid && currentNodeUuid.includes((item?.object as StorytellingRecord).Guid));
    }

    if (navigatation === NavigationDirection.FIRST) {
        return treeControl.dataNodes.find(item => item.level === baseLvls);
    }
    if (navigatation === NavigationDirection.LAST) {
        return treeControl.dataNodes.findLast(item => item.level === baseLvls);
    }
    if (navigatation === NavigationDirection.PREVIOUS) {
        const prevItemIdx = treeControl.dataNodes.findLastIndex((item, index) => {
            return index < currentIndex && item.level === baseLvls;
        });
        if (prevItemIdx > -1) {
            return treeControl.dataNodes[prevItemIdx];
        } else {
            return navigateTo(NavigationDirection.LAST, currentNodeUuid, treeControl, vs, baseLvl);
        }
    }
    if (navigatation === NavigationDirection.NEXT) {
        const nextItemIdx = treeControl.dataNodes.findIndex((item, index) => {
            return index > currentIndex && item.level === baseLvls;
        });
        if (nextItemIdx > -1) {
            return treeControl.dataNodes[nextItemIdx];
        } else {
            return navigateTo(NavigationDirection.FIRST, currentNodeUuid, treeControl, vs, baseLvl);
        }
    }
};
export const navigateDirectly = (nodeUniqueId: string, treeControl: FlatTreeControl<TreeLikeFlatNode<unknown>, string>) => {
    return treeControl.dataNodes.find(item => item?.uniqueId === nodeUniqueId);
};

export const navigateToImage = (navigatation: NavigationDirection, currentMedia: string, images: string[]) => {
    const currentIndex = images?.findIndex(item => item === currentMedia);

    if (navigatation === NavigationDirection.FIRST) {
        return images.find(item => item === images[0]);
    }
    if (navigatation === NavigationDirection.LAST) {
        return images.findLast(item => item === images[images.length - 1]);
    }
    if (navigatation === NavigationDirection.PREVIOUS) {
        const prevItemIdx = images.findLastIndex((item, index) => {
            return index < currentIndex && item === images[index];
        });
        if (prevItemIdx > -1) {
            return images[prevItemIdx];
        } else {
            return navigateToImage(NavigationDirection.LAST, currentMedia, images);
        }
    }
    if (navigatation === NavigationDirection.NEXT) {
        const nextItemIdx = images.findIndex((item, index) => {
            return index > currentIndex && item === images[index];
        });
        if (nextItemIdx > -1) {
            return images[nextItemIdx];
        } else {
            return navigateToImage(NavigationDirection.FIRST, currentMedia, images);
        }
    }
};

export const navigateToStory = (navigatation: NavigationDirection, currentIndex: number, storyIdxs: StorytellingStoryRecord[]): StorytellingStoryRecord => {
    switch (navigatation) {
        case NavigationDirection.FIRST:
            return storyIdxs[0];
        case NavigationDirection.LAST:
            return storyIdxs[storyIdxs.length - 1];
        case NavigationDirection.PREVIOUS:
            if (currentIndex > 0) {
                return storyIdxs[currentIndex - 1];
            } else {
                return navigateToStory(NavigationDirection.LAST, currentIndex, storyIdxs);
            }
        case NavigationDirection.NEXT:
            if (currentIndex < storyIdxs.length - 1) {
                return storyIdxs[currentIndex + 1];
            } else {
                return navigateToStory(NavigationDirection.FIRST, currentIndex, storyIdxs);
            }
        default:
            return storyIdxs[currentIndex];
    }
};

export const extractLowestNodeLevel = (dataNodes: TreeLikeFlatNode<StorytellingRecord>[]) => {
    if (dataNodes.length === 0) {
        return null;
    }
    let lvl = -1;
    dataNodes.forEach(node => {
        if (node.level > lvl) {
            lvl = node.level;
        }
    });
    if (lvl === -1) {
        return null;
    }
    return lvl;
};
